import { useState } from "react";

interface SlideoutControls {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export interface UseRoomSlideoutsReturn {
  resources: SlideoutControls;
  members: SlideoutControls;
  chat: SlideoutControls;
  events: SlideoutControls;
}

export const useRoomSlideouts = (): UseRoomSlideoutsReturn => {
  const [resourcesSlideoutOpen, setResourcesSlideoutOpen] = useState(false);
  const [membersSlideoutOpen, setMembersSlideoutOpen] = useState(false);
  const [chatSlideoutOpen, setChatSlideoutOpen] = useState(false);
  const [eventsSlideoutOpen, setEventsSlideoutOpen] = useState(false);

  return {
    chat: {
      close: () => setChatSlideoutOpen(false),
      isOpen: chatSlideoutOpen,
      open: () => setChatSlideoutOpen(true),
    },
    events: {
      close: () => setEventsSlideoutOpen(false),
      isOpen: eventsSlideoutOpen,
      open: () => setEventsSlideoutOpen(true),
    },
    members: {
      close: () => setMembersSlideoutOpen(false),
      isOpen: membersSlideoutOpen,
      open: () => setMembersSlideoutOpen(true),
    },
    resources: {
      close: () => setResourcesSlideoutOpen(false),
      isOpen: resourcesSlideoutOpen,
      open: () => setResourcesSlideoutOpen(true),
    },
  };
};
